interface EventSetting {
  venue?: string;
  zipCode?: string;
  facilityId?: string;
  facilityName?: string;
  facilityRoomArea?: string;
}

export const formatEventLocation = (setting: string | EventSetting): string => {
  if (typeof setting === 'string')
    return 'Online Event';


  if ('venue' in setting)
    return setting.venue || '';


  if ('facilityId' in setting && setting.facilityName) {
    const facilityName = setting.facilityName;
    const roomArea = setting.facilityRoomArea;

    return roomArea ? `${facilityName} - ${roomArea}` : facilityName;
  }

  return '';
};
